// extracted by mini-css-extract-plugin
module.exports = {"menu":"desktop_type-module__menu--cQYE5"};